<template>
  <el-col
    v-bind="$attrs"
  >
    <div class="card">
      <slot>
      </slot>
    </div>
  </el-col>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .card {
    padding: 32px 32px 36px 32px;
    background-color: $lighter-gray;
  }
</style>
